// TODO: Convert transcript-viewer.html to this component
// Use: useQuery to fetch transcript from /api/transcript/:roomId

export default function TranscriptViewerPage() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>📝 Transcript Viewer</h1>
      <p style={{ color: 'var(--text-secondary)' }}>
        View interview transcripts here
      </p>
    </div>
  )
}
